<div class="page-sub-title">My Profile</div>
<app-add-edit-player (saved)="onProfileSaved()" (canceled)="onCancelProfileUpdateClicked()" [playerToUpdate]="player"></app-add-edit-player>
